import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe } from '@angular/common';
import { CostCalculationRoutingModule } from './cost-calculation-routing.module';
import { CloudComputingFormComponent } from './cloud-computing-form/cloud-computing-form.component';
import { ContractorFormComponent } from './connected-subcontractor-form/connected-subcontractor-form.component';
import { ConnectedEpwByProjectFormComponent } from './connected-epw-by-project-form/connected-epw-by-project-form.component';
import { DataLicenceFormComponent } from './data-licence-form/data-licence-form.component';
import { EPWCostsByProjectFormComponent } from './epw-cost-by-project-form/epw-cost-by-project-form.component';
import { MaterialConsumableFormComponent } from './material-consumable-form/material-consumable-form.component';
import { SoftwareProjectFormComponent } from './software-project-form/software-project-form.component';
import { StaffCostFormComponent } from './staff-cost-form/staff-cost-form.component';
import { SubContractorFormComponent } from './sub-contractor-unconnected-form/sub-contractor-unconnected-form.component';
import { UtilityFormComponent } from './utility-form/utility-form.component';
import { CommonCostFormModule } from '../../../component/common-costing-form/common-cost-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../component/shared.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { CustomCurrencyPipe } from '../../../common/pipes/custom-currency.pipe';
import { PaymentsToClinicalTrialParticipantsComponent } from './payments-to-clinical-trial-participants-form/payments-to-clinical-trial-participants-form.component';
import { CustomPercentagePipe } from '../../../common/pipes/custom-percentage.pipe';
import { CustomPipe } from '../../../common/pipes/custom.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ExpenditureCostCategoryComponent } from './expenditure-cost-category.component';
import { MatTabsModule } from '@angular/material/tabs';
import { NumberCommaDirectiveimplements } from '../../../core/directive/directive/number-comma.directive';


@NgModule({
  declarations: [
    CloudComputingFormComponent,
    ContractorFormComponent,
    ConnectedEpwByProjectFormComponent,
    DataLicenceFormComponent,
    EPWCostsByProjectFormComponent,
    MaterialConsumableFormComponent,
    PaymentsToClinicalTrialParticipantsComponent,
    SoftwareProjectFormComponent,
    StaffCostFormComponent,
    SubContractorFormComponent,
    UtilityFormComponent,
    CustomCurrencyPipe,
    ExpenditureCostCategoryComponent,
    CustomPercentagePipe,
    CustomPipe,
    NumberCommaDirectiveimplements
  ],
  imports: [
    CommonModule,
    CostCalculationRoutingModule,
    CommonCostFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    MatTableModule,
    NgbModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSelectModule,
    FormsModule,
    SharedModule,
    MatExpansionModule,
    MatInputModule,
    NgSelectModule,
    MatTooltipModule,
    MatTableModule,
    MatTabsModule
  ],
  providers: [
    DecimalPipe,
    CustomCurrencyPipe,
    CustomPercentagePipe,
    CustomPipe,
    DatePipe
  ],
  exports:[
    CustomCurrencyPipe,
    CustomPercentagePipe,
    CustomPipe,
    DatePipe,
    NumberCommaDirectiveimplements
  ]
})
export class CostCalculationModule { }
